import { combineReducers } from "redux";
import { adminDataReducer } from "./adminData/adminDataReducer";
import { adminAnketasReducer } from "./adminAnketas/adminAnketasReducer";
import { adminEditCommentModeReducer } from "./adminEditAnketaMode/adminEditAnketaModeReducer";

export const adminRootReducer = combineReducers({
    adminData: adminDataReducer,
    anketasData: adminAnketasReducer,
    adminEditCommentMode: adminEditCommentModeReducer
});